/* eslint react-hooks/exhaustive-deps: "warn" */

import type { CSSProperties } from 'react';

import cn from 'classnames';

import styles from './ComparisonMatrix.module.scss';

import type { ComparisonMatrixProps } from './ComparisonMatrix.types';

export const ComparisonMatrix = ({ usLabel, themLabel, rows, className }: ComparisonMatrixProps) => (
  <div className={cn(styles.compare, className)}>
    <div className={styles.glow} aria-hidden="true" />

    <div className={cn(styles.row, styles.head)}>
      <div className={styles.feat} />
      <div className={cn(styles.us, styles.brand)}>{usLabel}</div>
      <div className={styles.them}>{themLabel}</div>
    </div>

    {rows.map((row, i) => (
      <div className={styles.row} style={{ '--row-delay': `${i * 60}ms` } as CSSProperties} key={row.feature}>
        <div className={styles.feat}>{row.feature}</div>
        <div className={styles.us}>{row.us}</div>
        <div className={cn(styles.them, row.themNegative && styles.themNo)}>{row.them}</div>
      </div>
    ))}
  </div>
);
